import { render, staticRenderFns } from "./devmode-button.component.vue?vue&type=template&id=2fd63f31"
import script from "./devmode-button.component.ts?vue&type=script&lang=ts&external"
export * from "./devmode-button.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports